module.exports = __webpack_public_path__ + "img/type_img02.37476aa7.png";